/**
 * @description Ações relacionadas a manipulação de idsState no sistema
 * @author Bene Lemuel Dantas Gondim
 * @file idsStateActions.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

export const ID_ORGAO = 'ID_ORGAO'
export const ID_REGIONAL = 'ID_REGIONAL'
export const ID_DIVISAO = 'ID_DIVISAO'
export const ID_SETOR = 'ID_SETOR'
export const ID_CARGO = 'ID_CARGO'
export const ID_USUARIO = 'ID_USUARIO'
export const ID_EXAME = 'ID_EXAME'
export const ID_CASO = 'ID_CASO'
export const ID_VESTIGIO = 'ID_VESTIGIO'
export const ID_SOLICITACAO_EXAME = 'ID_SOLICITACAO_EXAME'
export const ID_EXAME_SOLICITADO = 'ID_EXAME_SOLICITADO'
export const ID_CENTRAL_CUSTODIA = 'ID_CENTRAL_CUSTODIA'
export const ID_EXAME_REALIZADO = 'ID_EXAME_REALIZADO'
export const ID_PERICIANDO = 'ID_PERICIANDO'
export const ID_CADAVER = 'ID_CADAVER'
export const ID_LOCAL = 'ID_LOCAL'
export const ID_VEICULO = 'ID_VEICULO'
export const ID_SECAO_EXAME = 'ID_SECAO_EXAME'

export const setIdOrgao = (idOrgao) => async (dispatch) => {
  dispatch({
    type: ID_ORGAO,
    idOrgao,
  })
}

export const setIdRegional = (idRegional) => async (dispatch) => {
  dispatch({
    type: ID_REGIONAL,
    idRegional,
  })
}

export const setIdDivisao = (idDivisao) => async (dispatch) => {
  dispatch({
    type: ID_DIVISAO,
    idDivisao,
  })
}

export const setIdSetor = (idSetor) => async (dispatch) => {
  dispatch({
    type: ID_SETOR,
    idSetor,
  })
}

export const setIdCargo = (idCargo) => async (dispatch) => {
  dispatch({
    type: ID_CARGO,
    idCargo,
  })
}

export const setIdUsuario = (idUsuario) => async (dispatch) => {
  dispatch({
    type: ID_USUARIO,
    idUsuario,
  })
}

export const setIdExame = (idExame) => async (dispatch) => {
  dispatch({
    type: ID_EXAME,
    idExame,
  })
}

export const setIdCaso = (idCaso) => async (dispatch) => {
  dispatch({
    type: ID_CASO,
    idCaso,
  })
}

export const setIdVeiculo = (idVeiculo) => async (dispatch) => {
  dispatch({
    type: 'ID_VEICULO',
    idVeiculo,
  })
}
export const setIdVestigio = (idVestigio) => async (dispatch) => {
  dispatch({
    type: ID_VESTIGIO,
    idVestigio,
  })
}

export const setIdSecaoExame = (idSecaoExame) => async (dispatch) => {
  dispatch({
    type: ID_SECAO_EXAME,
    idSecaoExame,
  })
}

export const setIdSolicitacaoExame = (idSolicitacaoExame) => async (dispatch) => {
  dispatch({
    type: ID_SOLICITACAO_EXAME,
    idSolicitacaoExame,
  })
}

export const setIdExameSolicitado = (idExameSolicitado) => async (dispatch) => {
  dispatch({
    type: ID_EXAME_SOLICITADO,
    idExameSolicitado,
  })
}

export const setIdExameRealizado = (idExameRealizado) => async (dispatch) => {
  dispatch({
    type: ID_EXAME_REALIZADO,
    idExameRealizado,
  })
}

export const setIdCentralCustodia = (idCentralCustodia) => async (dispatch) => {
  dispatch({
    type: ID_CENTRAL_CUSTODIA,
    idCentralCustodia,
  })
}

export const setIdPericiando = (idPericiando) => async (dispatch) => {
  dispatch({
    type: ID_PERICIANDO,
    idPericiando,
  })
}

export const setIdCadaver = (idCadaver) => async (dispatch) => {
  dispatch({
    type: ID_CADAVER,
    idCadaver,
  })
}

export const setIdLocal = (idLocal) => async (dispatch) => {
  dispatch({
    type: ID_LOCAL,
    idLocal,
  })
}
